import React, { Component } from 'react';
import { Modal, Button,  DatePicker, message, Upload  } from 'antd';
import AjaxRequest, { xToken } from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';
import RefuseTransfer from './RefuseTransfer';
import moment from 'moment';

const initialState = {
    investigationCode: '',
    investigationName: '',
    investigationSiteCode: '',
    investigationSiteName: '',
    handoverUser: '',
    assignedUsers: {},
    Type_Filter: '',
    Type_Informed: '',
    Type_Random: '',
    Type_Drop: '',
    Type_Violation: '',
    Type_SAE: '',
    Type_VisitType: '',
    PlanType_Filter: '',
    PlanType_Informed: '',
    PlanType_Random: '',
    handoverBeginDate: '',
    handoverEndDate: '',
    localeHandoverBeginDate: '',
    localeHandoverEndDate: '',
    completeTime: '',
    visible: false,
    dateFormat: "YYYY-MM-DD",
    submitLoading: false,
    saveLoading: false,
    status: '',
    handoverUserId: '',
    isEdit: false,
    returnLoading: false,
    requirementId : '',
    submitting : false,
    confirmLoading: false,
    planFileList: [],
    reportFileList: [],
};

class ViewReportModal extends Component {
    state = initialState;

    show = (id, isEdit) => {
        const edit = isEdit ? true : false;
        this.setState({
            visible: true,
            requirement: {},
            fteList: [],
            city: '',
            requirementId : '',
            isEdit: edit
        });
        if (id) {
            this.loadData(id);
        }
    };

    reset = () => {
        this.setState(initialState);
        this.props.reload();
    }

    hide = () => {
        this.setState({ visible: false });
    };

    dateChange = (field, value) =>{
        const { dateFormat } = this.state;
        this.setState({ [field] : value ? moment(value).format(dateFormat): null });
    }

    getDate = (date) =>{
        const { dateFormat } = this.state;
        if (date) {
            return moment(date).format(dateFormat)
        } else {
            return "";
        }
        
    }

    getDatePicker = (date, name) =>{
        const { dateFormat } = this.state;
        if (date == "") {
            return (<DatePicker onChange={this.dateChange.bind(this, name)} format={dateFormat} />)
        } else {
            return (<DatePicker onChange={this.dateChange.bind(this, name)} value={date ? moment(date) : null} format={dateFormat} />)
        }
        
    }

    handleSubmitAjax = (nodeliver) => {
        const { checkList, requirementId, handoverBeginDate, handoverEndDate, localeHandoverBeginDate, localeHandoverEndDate, planFileList, reportFileList } = this.state;
        const loading = nodeliver ? "saveLoading" : "submitLoading";
        this.setState({ [loading] : true });
        
        let checkItems = '';
        checkList.map((value,index) =>{
            checkItems += `&checkList[${index}].handoverCheckListId=${value.handoverCheckListId}`;
            checkItems += `&checkList[${index}].remark=${value.remark || ''}`;
            checkItems += `&checkList[${index}].itemChecked=${value.itemChecked}`;
        })
        if(loading == "submitLoading"){
            if (planFileList.length <= 0) {
                message.error(`请上传研究中心工作交接计划附件`);
                this.setState({ [loading]: false});
                return;
            } else if (reportFileList <= 0) {
                message.error(`请上传研究中心工作交接报告附件`);
                this.setState({ [loading]: false});
                return;
            }

            let errMsg = "";
            if(!handoverBeginDate){
                errMsg += "交接开始日期 "
            }
            if(!handoverEndDate){
                errMsg += "交接结束日期 "
            }
            if(!localeHandoverBeginDate){
                errMsg += "现场交接开始日期 "
            }
            if(!localeHandoverEndDate){
                errMsg += "现场交接结束日期 "
            }
            
            if(!handoverBeginDate || !handoverEndDate || !localeHandoverBeginDate || !localeHandoverEndDate){
                message.error(`请填写${errMsg}`);
                this.setState({ [loading]: false});
                return;
            }
        }
        let param = `requirementId=${requirementId}${checkItems}&handoverBeginDate=${handoverBeginDate || ''}&handoverEndDate=${handoverEndDate || ''}&localeHandoverBeginDate=${localeHandoverBeginDate || ''}&localeHandoverEndDate=${localeHandoverEndDate || ''}`;
        if(!nodeliver){
            param += "&deliver=1";
        }
        
        const options = {
            method: 'POST',
            url: `${API_URL.execute.saveHandoverReport}?${param}`,
            doneResult: data => {
                this.setState({ [loading]: false});
                message.success('提交成功');
                this.props.reload();
                this.reset();
            },
            errorResult: data => {
                this.setState({ [loading]: false});
            },
        };
        AjaxRequest.sendRequest(options);
    }

    handleSave = () => {
        this.handleSubmitAjax(true);
    }

    handleSubmit = () => {
        this.handleSubmitAjax(false);
    }

    confirmCompleteReport = () =>{
        Modal.confirm({
            title: '确认完成',
            content: (<span className="confirmText">确认该交接报告完成?</span>),
            okText: '确认',
            cancelText: '取消',
            onOk: this.submitCompleteReport
          });
    }

    submitCompleteReport = () => {
        const {requirementId} = this.state;
        const options = {
            method: 'POST',
            url: `${API_URL.execute.completeHandover}?requirementId=${requirementId}`,
            doneResult: data => {
                message.success('操作成功');
                this.reset();
            },
        };
        AjaxRequest.sendRequest(options);
    }

    refuseTransfer = id => {
        this.refuseTransferRef.show(id);
    }

    getAssignUserNames = () =>{
        const {assignedUsers} = this.state;
        let Users = "";
        for(let key in assignedUsers){
            Users += assignedUsers[key] + ";";
        }
        var lastIndex = Users.lastIndexOf(";");
        Users = Users.substring(0, lastIndex);
        return Users;
    }

    isAssignUser = () =>{
        const {assignedUsers} = this.state;
        const userId = sessionStorage.userId;
        let UserIds = [];
        for(let key in assignedUsers){
            UserIds.push(key);
        }
        if(UserIds.indexOf(userId) < 0){
            return false;
        }else{
            return true;
        }
    }

    loadData = id => {
        this.setState({
            processedEmployees : [],
            requirement: null,
            fteList : [],
            city : '',
            employees : [],
            requirementId : id,
            employeesLoading : true,
        })
        const options = {
            method: 'POST',
            url: `${API_URL.user.queryHandoverReport}?requirementId=${id}`,
            doneResult: ( data => {
                    const {dateFormat} = this.state;
                    const {actualSummary, checkList, handover, planList, site, requirementFileMetaList} = data.data.handoverReport;
                    const {Type_Drop, Type_Filter, Type_Informed, Type_Random, Type_SAE, Type_Violation, Type_VisitType} = actualSummary;
                    const {handoverUser, assignedUserList, requirementId, handoverUserId, status, handoverBeginDate, completeTime, handoverEndDate, localeHandoverBeginDate, localeHandoverEndDate} = handover;
                    const {investigationCode, investigationName} =  site.investigation;
                    const {investigationSiteCode, investigationSiteName} = site;
                    const PlanType_Filter = planList.Type_Filter;
                    const PlanType_Informed = planList.Type_Informed;
                    const PlanType_Random = planList.Type_Random;
                    const assignedUsers = {};
                    assignedUserList.map((value,index) => {
                        assignedUsers[value.userId] = value.userName;
                    })

                    const planFileList = [], reportFileList = [];
                    if (requirementFileMetaList && requirementFileMetaList.length > 0) {
                        requirementFileMetaList.map(item => {
                            if (item.fileType == 'plan') {
                                item.uid = planFileList.length;
                                item.response = {fileMetaId: item.fileMetaId};
                                planFileList.push(item);
                            } else if (item.fileType == 'report') {
                                item.uid = reportFileList.length;
                                item.response = {fileMetaId: item.fileMetaId};
                                reportFileList.push(item);
                            }
                        })
                    }
                    this.setState({
                        investigationCode,
                        investigationName,
                        investigationSiteCode,
                        investigationSiteName,
                        handoverUser,
                        assignedUsers,
                        Type_Filter,
                        Type_Informed,
                        Type_Random,
                        Type_Drop,
                        Type_Violation,
                        Type_SAE,
                        Type_VisitType,
                        PlanType_Filter,
                        PlanType_Informed,
                        PlanType_Random,
                        checkList,
                        handoverBeginDate: handoverBeginDate ? moment(handoverBeginDate).format(dateFormat) : "",
                        handoverEndDate: handoverEndDate ? moment(handoverEndDate).format(dateFormat) : "",
                        localeHandoverBeginDate: localeHandoverBeginDate ? moment(localeHandoverBeginDate).format(dateFormat) : "",
                        localeHandoverEndDate: localeHandoverEndDate ? moment(localeHandoverEndDate).format(dateFormat): "",
                        completeTime,
                        status,
                        handoverUserId,
                        requirementId,
                        planFileList,
                        reportFileList,
                    });
                }
            ),
        };
        AjaxRequest.sendRequest(options);
    }

    loadFileList = () => {
        const { investigationJdeContractId } = this.state.jdeData;
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeCodeEnclosure,
            data: {
                investigationJdeContractId,
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.data;
                fileList.forEach((item, index) => {
                    item.response = {fileMetaId: item.id};
                    item.uid = index;
                });
                this.setState({ fileList });
            }
        }
        AjaxRequest.sendRequest(options)
    }

    beforeUpload = (file, type) => {
        const { planFileList = [], reportFileList = [] } = this.state;
        const isLt20M = file.size / 1024 / 1024 <= 50;
        if (!isLt20M) {
            message.warning('文件大小不能超过50M');
            return false;
        }
        if (planFileList.length >= 10 || reportFileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
    };

    handleChange = ({file, fileList}, type) => {
        if (type == 'plan') {
            if (file.status == "done") {
                if (file.response.error) {  
                    message.error(file.response.error);
                    file.status = 'removed';
                    const fileData = [...this.state.planFileList];
                    const index = fileData.indexOf(file);
                    fileList.splice(index, 1);
                } else if (file.response.success) {
                    message.success('上传附件成功');
                }
            }
            this.setState({ planFileList: fileList });
        } else if (type == 'report') {
            if (file.status == "done") {
                if (file.response.error) {  
                    message.error(file.response.error);
                    file.status = 'removed';
                    const fileData = [...this.state.reportFileList];
                    const index = fileData.indexOf(file);
                    fileList.splice(index, 1);
                } else if (file.response.success) {
                    message.success('上传附件成功');
                }
            }
            this.setState({ reportFileList: fileList });
        }
    }

    handleRemove = file => {
        const options = {
            method: 'POST',
            url: API_URL.execute.deleteRequirementEnclosure,
            data: {
                fileMetaId: file.response.fileMetaId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.error) {
                    message.error(res.error);
                } else {
                    message.success(res.success);
                }
            }
        };
        AjaxRequest.sendRequest(options);
    }

    getNodeList = (list) => {
        let data;
        if (list.length > 0) {
            data = list.map(item => <span key={item.fileMetaId}><a onClick={e => this.downLoadFile(e, item.fileMetaId)}>{item.name}</a><br/></span>);
        }
        return data;
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: fileMetaId}, null, url);
    }

    render() {
        const {
            investigationCode,
            investigationName,
            investigationSiteCode,
            investigationSiteName,
            handoverUser,
            Type_Filter,
            Type_Informed,
            Type_Random,
            Type_Drop,
            Type_Violation,
            Type_SAE,
            Type_VisitType,
            PlanType_Filter,
            PlanType_Informed,
            PlanType_Random,
            handoverBeginDate,
            handoverEndDate,
            localeHandoverBeginDate,
            localeHandoverEndDate,
            handoverUserId,
            submitLoading,
            saveLoading,
            status,
            isEdit,
            returnLoading,
            requirementId,
            completeTime,
            confirmLoading,
            visible,
            planFileList,
            reportFileList,
        } = this.state;
        const { src } = this.props;
        let footerDom;
        if((status == "UNDERWAY" || status == "RETURNED") && (handoverUserId == sessionStorage.userId || this.isAssignUser()) && src == 'Execute'){
            footerDom = [
                <Button key="handleSubmit" type="primary" size="large" loading={submitLoading} onClick={this.handleSubmit}>
                    保存并提交
                </Button>,
                <Button key="save" type="primary" size="large" loading={saveLoading} onClick={this.handleSave}>
                    保存
                </Button>,
                <Button key="back" size="large" onClick={this.hide}>取消</Button>,
            ];
        }else if(status == "RECEIVED" && (sessionStorage.curRole == "PM" || sessionStorage.curRole == "PA")){
            footerDom = [
                <Button key="submit" type="primary" loading={submitLoading} onClick={() => this.props.canEditByInvStatus(this.confirmCompleteReport)}>
                    确认完成
                </Button>,
                <Button key="back" loading={returnLoading} onClick={() => this.props.canEditByInvStatus(() => this.refuseTransfer(requirementId))}>打回</Button>,
            ];
        }else if(status == "UNDERWAY" && sessionStorage.curRole == "PM" && isEdit){
            footerDom = [
                <Button key="handleSubmit" type="primary" size="large" loading={submitLoading} onClick={this.handleSubmit}>
                    保存并提交
                </Button>,
                <Button key="save" type="primary" size="large" loading={saveLoading} onClick={this.handleSave}>
                    保存
                </Button>,
                <Button key="back" size="large" onClick={this.hide}>取消</Button>,
            ];
        }else{
            footerDom = [
                <Button key="back" size="large" onClick={this.hide}>关闭</Button>
            ];
        }
        const title = isEdit ? "填写交接报告" : "查看交接报告" 
        return (
            <div>
            <Modal
                visible={visible}
                title={title}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal"
                width="1000px"
                bodyStyle={{ maxHeight: 600 }}
                confirmLoading={confirmLoading}
                footer={footerDom}
            >
                <div style={{ textAlign: 'center' }}>
                    {/* <label style={{ fontSize: `${16}px` }}>{title}</label> */}
                </div>
                <br />
                <hr />
                <div className="cont-cont"  style={{ marginTop: 10 }}>
                    <ul className="preview-list">
                        <li className="title preview-item"><h4>1.基本信息</h4></li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">项目编号</label>
                                <span className="ui-text">{investigationCode}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">项目简称</label>
                                <span className="ui-text">{investigationName}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">中心编号</label>
                                <span className="ui-text">{investigationSiteCode}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">中心名称</label>
                                <span className="ui-text">{investigationSiteName}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">前任CRC</label>
                                <span className="ui-text">{handoverUser}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">现任CRC</label>
                                <span className="ui-text">
                                    {this.getAssignUserNames()}
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">计划筛选数</label>
                                <span className="ui-text">{PlanType_Filter}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">实际筛选数</label>
                                <span className="ui-text">{Type_Filter}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">计划知情数</label>
                                <span className="ui-text">{PlanType_Informed}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">实际知情数</label>
                                <span className="ui-text">{Type_Informed}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">计划随机(入组)数</label>
                                <span className="ui-text">{PlanType_Random}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">实际随机(入组)数</label>
                                <span className="ui-text">{Type_Random}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">病人退出数</label>
                                <span className="ui-text">{Type_Drop}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">方案违背数</label>
                                <span className="ui-text">{Type_Violation}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">SAE数</label>
                                <span className="ui-text">{Type_SAE}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">完成访视数</label>
                                <span className="ui-text">{Type_VisitType}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <hr />
                <div className="cont-cont" style={{ marginTop: 10 }}>
                    <h3>2.附件</h3>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{marginRight: 30}}>研究中心工作交接计划</label>
                                <span className="ui-text" style={{width: 400}}>
                                    {
                                        isEdit
                                        ?
                                            <Upload
                                                action={API_URL.execute.uploadRequirementEnclosure}
                                                data={{
                                                    fileType: 'plan',
                                                    requirementId,
                                                    path: Date.now(),
                                                    curUserId: sessionStorage.userId,
                                                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                                }}
                                                beforeUpload={(file) => this.beforeUpload(file, 'plan')}
                                                onChange={({file, fileList}) =>this.handleChange({file, fileList}, 'plan')}
                                                onRemove={this.handleRemove}
                                                fileList={planFileList}
                                                headers={xToken}
                                            >
                                                <Button style={{width: 80}}>选择文件</Button>
                                            </Upload>
                                        :
                                            planFileList && this.getNodeList(planFileList)
                                    } 
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label" style={{marginRight: 30}}>研究中心工作交接报告</label>
                                <span className="ui-text" style={{width: 400}}>
                                    {
                                        isEdit
                                        ?
                                            <Upload
                                                action={API_URL.execute.uploadRequirementEnclosure}
                                                data={{
                                                    fileType: 'report',
                                                    requirementId,
                                                    path: Date.now(),
                                                    curUserId: sessionStorage.userId,
                                                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                                }}
                                                beforeUpload={(file) => this.beforeUpload(file, 'report')}
                                                onChange={({file, fileList}) =>this.handleChange({file, fileList}, 'report')}
                                                onRemove={this.handleRemove}
                                                fileList={reportFileList}
                                                headers={xToken}
                                            >
                                                <Button style={{width: 80}}>选择文件</Button>
                                            </Upload>
                                        :
                                            reportFileList && this.getNodeList(reportFileList)
                                    }
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <hr />
                <div className="cont-cont" style={{ marginTop: 10 }}>
                    <h3>3.交接确认</h3>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">交接开始日期</label>
                                <div className="ui-text">
                                    {isEdit ?
                                        this.getDatePicker(handoverBeginDate, "handoverBeginDate")
                                    :
                                    this.getDate(handoverBeginDate)
                                    }
                                </div>
                            </div>
                            <div className="item">
                                <label className="ui-label">交接结束日期</label>
                                <div className="ui-text">
                                    {isEdit ?
                                        this.getDatePicker(handoverEndDate, "handoverEndDate")
                                    :
                                    this.getDate(handoverEndDate)}
                                </div>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">现场交接开始日期</label>
                                <div className="ui-text">
                                    {isEdit ?
                                        this.getDatePicker(localeHandoverBeginDate, "localeHandoverBeginDate")
                                    :
                                    this.getDate(localeHandoverBeginDate)}
                                </div>
                            </div>
                            <div className="item">
                                <label className="ui-label">现场交接结束日期</label>
                                <div className="ui-text">
                                    {isEdit ?
                                        this.getDatePicker(localeHandoverEndDate, "localeHandoverEndDate")
                                    :
                                    this.getDate(localeHandoverEndDate)}
                                </div>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">PM确认日期</label>
                                <div className="ui-text">
                                    {this.getDate(completeTime)}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
            <RefuseTransfer
                ref={el => { this.refuseTransferRef = el; }}
                reload={this.reset}
            />
            </div>
        );
    }
}

export default ViewReportModal;



// WEBPACK FOOTER //
// ./src/components/user/transfer/components/ViewReport.js